export const G_namedProperties = new Set([
  "transform",
  "filter",
  "backdrop-filter",
  "get",
  "set",
  "add",
  "remove",
  "toggle",
]);
